<template>
  <section class="hero">
    <div class="hero-body">
      <!-- carousel -->
      <agile :arrows="false" :speed="1200"
        :autoplaySpeed="5000"
        :timing="'linear'" :fade="true"
        :autoplay="true" :pauseOnHover="false">
        <img class="slide slide--1" :src="require('assets/carousel_1@2x.png')" alt="">
        <img class="slide slide--2" :src="require('assets/carousel_2@2x.png')" alt="">
      </agile>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'carousel'
  }
</script>

<style lang="scss">
  .agile {
    position: relative;

    &, * {
      &:focus,
      &:active {
        outline: none;
      }
    }

    &__list {
      display: block;
      margin: 0;
      overflow: hidden;
      padding: 0;
      position: relative;
      width: 100%;
    }

    &__track {
      align-items: center;
      display: flex;
      justify-content: flex-start;

      .agile--disabled & {
        display: block;
        max-width: 100%;
      }
    }

    &__slide {
      display: block;

      .agile--fade & {
        opacity: 0;
        position: relative;
        z-index: 0;

        &--active {
          opacity: 1;
          z-index: 2;
        }

        &--expiring {
          opacity: 1;
          transition-duration: 0s;
          z-index: 1;
        }
      }
    }

    &__arrow {
      border: none;
      bottom: -11px;
      margin: 0;
      padding: 0;
      position: absolute;
      transition-duration: .3s;

      &[disabled] {
        cursor: default;
        opacity: .4;
      }

      &:hover {
        svg {
          fill: #333;
        }
      }

      &--prev {
        left: 0;
      }

      &--next {
        right: 0;
      }

      svg {
        fill: #888;
        height: 24px;
        transition-duration: .3s;
      }
    }

    &__dots {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      list-style: none;
      bottom: 10px;
      padding: 0;
      text-align: center;
      white-space: nowrap;
    }

    &__dot {
      margin: 0 4px;

      button {
        background-color: #a5c6ff;
        border: none;
        cursor: pointer;
        display: block;
        font-size: 0;
        line-height: 0;
        margin: 0;
        padding: 0;
        // transition-duration: .3s;
        border-radius: 50%;
        width: 8px;
        height: 8px;
      }

      &--current {
        button {
          border-radius: 4px;
          height: 8px;
          width: 56px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/Carousel.vue